import React from 'react'
import { connect } from 'react-redux'
import { GlobalState } from 'reducers'
import styles from './index.module.sass'
import { FreestyleItem, FreestyleContent as FreestyleContentIf } from 'types/data'
import { getActiveItemObject } from 'selectors/commonSelectors'

interface Props {
  opened: boolean,
  defaultContent: FreestyleContentIf,
  activeItem?: FreestyleItem
}

const FreestyleContent: React.FC<Props> = ({
  activeItem,
  defaultContent,
  opened
}) => {
  const targetContent = activeItem && activeItem.content[0]
  
  return (
    <div className={styles.contentWrapper_f}>
      <div  className={`${styles.contentContainer} ${!opened ? styles.pointerDisabled : ''}`}>
        <div className={styles.title}> 
          <p> {!targetContent ?  defaultContent.title : targetContent.title} </p>
          <p className={styles.subTitle}>{targetContent ? targetContent.subtitle : ''}</p>
        </div>
        <div 
          className={styles.text} 
          dangerouslySetInnerHTML={{__html: !targetContent ? defaultContent.text : targetContent.text}}
        >
        </div>
        <div className={styles.tips}>
            <p> {targetContent && targetContent.tip ? targetContent.tip : ''} </p>
        </div>
      </div>
    </div>
  )
}

export default connect(
  (state: GlobalState) => ({
    opened: state.freestyle.contentOpened,
    activeItem: getActiveItemObject(state),
    defaultContent: state.freestyle.data.content,
  })
)(FreestyleContent)
